var map = {
	"./AU-ANU.png": 478,
	"./AU-Melbourne.jpeg": 479,
	"./AU-Monash.png": 480,
	"./AU-NewSouthWales.png": 481,
	"./AU-SYDNEY.png": 482,
	"./AU-UQ.jpg": 483,
	"./CSU-Signature-Stacked-357-617.svg": 484,
	"./CTY-ISC-lockup-landscape-alternative-logo-fullColour-rgb.svg": 485,
	"./HK-EdUHK.jpeg": 486,
	"./HK-HKBU.png": 487,
	"./HK-HKMU.png": 488,
	"./HK-HKSYU.jpg": 489,
	"./HK-Lingnan.png": 490,
	"./HK-PolyU.png": 491,
	"./JAPAN-Keio.png": 492,
	"./JAPAN-Kyoto.png": 493,
	"./JAPAN-Nagoya.png": 494,
	"./JAPAN-OsakaU.jpg": 495,
	"./JAPAN-Waseda.png": 496,
	"./SING-Curtin.png": 497,
	"./SING-Newcastle.jpg": 498,
	"./SING-RMIT-SG.jpeg": 499,
	"./SING-RMIT-SG.png": 500,
	"./SING-UOW-SG.png": 501,
	"./SING-Ucd.png": 502,
	"./UK-Birmingham.png": 503,
	"./UK-Edinburgh.png": 504,
	"./UK-Glasgow.png": 505,
	"./UK-Lancaster.jpg": 506,
	"./UK-Leeds.png": 507,
	"./UK-London.png": 508,
	"./UK-Manchester.png": 509,
	"./UK-Sheffield.jpg": 510,
	"./USA- Ohio.jpeg": 511,
	"./USA-CWRU.jpg": 512,
	"./USA-California.jpg": 513,
	"./USA-California2.jpg": 514,
	"./USA-Pennsylvania.png": 515,
	"./USA-Purdue.png": 516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 477;